import React from 'react';
import { connect } from 'react-redux';

import EmailItem from 'settings/balance-sheet/EmailItem';

const EmailClient = ({ amount, tableStyle }) => (
  <tr data-bem="EmailClient">
    <td colSpan="2" style={{ padding: 0 }}>
      <table style={tableStyle}>
        <tbody>
          <tr key="services">
            <td colSpan="2" style={{ backgroundColor: ' #fff', padding: '0 50px' }}>
              <EmailItem
                tableStyle={tableStyle}
                itemType="service"
                item={{ service: 'Deposit refund' }}
                amount={amount}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </td>
  </tr>
);

const mapStateToProps = (state) => ({ clients: state.currentSalon.clientList });

const EmailClientHoc = connect(mapStateToProps)(EmailClient);

export default EmailClientHoc;
